import { render, staticRenderFns } from "./EntityTagsSection.vue?vue&type=template&id=6a4d14d8&scoped=true"
import script from "./EntityTagsSection.vue?vue&type=script&lang=js"
export * from "./EntityTagsSection.vue?vue&type=script&lang=js"
import style0 from "./EntityTagsSection.vue?vue&type=style&index=0&id=6a4d14d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4d14d8",
  null
  
)

export default component.exports